import React, { useState, useEffect, useRef } from "react"
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import "./Deflator.scss"

// function Deflator({model, gdp, setGdp, items = []}) {
function Deflator({model, gdp, setGdp, custom, setCustom, items = []}) {

  const [menu, displayMenu] = useState(false)
  
  let dropdownRef = useRef()

  useEffect(() => {

    let handler = (event) => {
      if (!dropdownRef.current.contains(event.target)) {
        displayMenu(false)
      }
    }
    document.addEventListener("mousedown", handler)

    switch (model) {
      case "Species":
        Window.vms.selectedDeflator({year: gdp.year, deflator: gdp.value})
        Window.vms.customDeflator(gdp.customValue)

      case "Gear":
        Window.vmg.selectedDeflator({year: gdp.year, deflator: gdp.value})
        Window.vmg.customDeflator(gdp.customValue)
        break;

      case "Charter":
        Window.vmc.selectedDeflator({year: gdp.year, deflator: gdp.value})
        Window.vmc.customDeflator(gdp.customValue)
        break;
    
      default:
        Window.vms.selectedDeflator({year: gdp.year, deflator: gdp.value})
        Window.vms.customDeflator(gdp.customValue)
        break;
    }

    return () => {
      document.removeEventListener("mousedown", handler)
    }

  },[gdp])

  const toggle = () => displayMenu(!menu)

  const selectGDP = (item) => {

    if (item.deflator !== 0) {
      setCustom(false)
      setGdp({ ...gdp, year: item.year, value: item.deflator})
    } else {
      setCustom(true)
      setGdp({...gdp, year: item.year, value: item.deflator})
    }
    toggle()
  }

  let itemsFiltered = items.filter(item => item.deflator !== 0)

  return (
    <div className="Deflator">
      <div className="ImpactYear">
        <h3 className="Header">Impact Year</h3>
        <div ref={dropdownRef} className="Dropdown">
          <div className="TopOption" onClick={toggle}>
            <h3 className="OptionSelected">{gdp.year}</h3>
            <FontAwesomeIcon className={menu ? "chevronUp" : "chevronDown"} icon={faChevronDown} />
          </div>
          <div className={menu ? "YearList_shown" : "YearList_hidden"}>
            <ul>
              {itemsFiltered.map(item => (
                 <li className="Option" key={item.id} onClick={() => selectGDP(item)}>
                    <h3 className="OptionName">{item.year}</h3>
                  </li>
              ))}
            </ul>
            <div className="CustomGDP">
              <h3 onClick={() => selectGDP(items[6])}>Custom GDP</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="GDPResult">
        <div className="GDPResultTop">
          <h3 className="Header">GDP Deflator Value</h3>
          <Tippy placement="top" content="All the values (in million dollars) in the initial MRSAM table are adjusted using the GDP deflator. 
                    So, for example, if the impact year is 2016 with the impact numbers given in 2016 values, we multiply 
                    all the elements in the initial MRSAM by the GDP deflator for the year."><div><FontAwesomeIcon icon={faInfoCircle} /></div></Tippy>  
        </div>

          <div className="TextBox">
            <h4 className={custom ? "disabled" : "enabled"}>{gdp.value}</h4>        
            <input id="customDeflatorInput" className={`GDPInput ${custom ? "enabled" : "disabled"}`} maxLength="12"
            placeholder="Type the value" onChange={e => {setGdp({...gdp, customValue: Number(e.target.value)})}} />
          </div>
        </div>
    </div>
  )
}

export default Deflator
